import {
  // Figure Data
  NS_GET_FIGURE_DATA,
  NS_GET_FIGURE_DATA_SUCCESS,
  NS_GET_FIGURE_DATA_FAIL,

  // Alerts and Hits data
  NS_GET_ALERTS_HITS_CHART,
  NS_GET_ALERTS_HITS_CHART_SUCCESS,
  NS_GET_ALERTS_HITS_CHART_FAIL,

  // Hits Distribution data
  NS_GET_HITS_DISTRIBUTION_CHART,
  NS_GET_HITS_DISTRIBUTION_CHART_SUCCESS,
  NS_GET_HITS_DISTRIBUTION_CHART_FAIL,

  // Segments data
  NS_GET_SEGMENTS,
  NS_GET_SEGMENTS_SUCCESS,
  NS_GET_SEGMENTS_FAIL,

  // Segments data
  NS_GET_BUSINESS_SEGMENTS_PARAMETERS_DATA,
  NS_GET_BUSINESS_SEGMENTS_PARAMETERS_DATA_SUCCESS,
  NS_GET_BUSINESS_SEGMENTS_PARAMETERS_DATA_FAIL,

  // Customer View data
  NS_GET_CUSTOMER_VIEW_DATA,
  NS_GET_CUSTOMER_VIEW_DATA_SUCCESS,
  NS_GET_CUSTOMER_VIEW_DATA_FAIL
} from '../../actions/ns/dashboard';

export const initialState = {
  figures: { isLoading: false, data: null, error: null },
  alertsAndHits: { isLoading: false, data: null, error: null },
  hitYield: { isLoading: false, data: null, error: null },
  hitsDistribution: { isLoading: false, data: null, error: null },
  segments: { isLoading: false, data: null, error: null },
  customerView: { isLoading: false, data: null, error: null },
  businessSegmentsParameters: { isLoading: false, data: null, error: null }
};

export default function riskview(state = initialState, action) {
  switch (action.type) {
    case NS_GET_FIGURE_DATA:
      return {
        ...state,
        figures: { isLoading: true, data: [], error: null }
      };

    case NS_GET_ALERTS_HITS_CHART:
      return {
        ...state,
        alertsAndHits: { isLoading: true, data: [], error: null }
      };

    case NS_GET_HITS_DISTRIBUTION_CHART:
      return {
        ...state,
        hitsDistribution: { isLoading: true, data: [], error: null }
      };

    case NS_GET_SEGMENTS:
      return {
        ...state,
        segments: { isLoading: true, data: [], error: null }
      };

    case NS_GET_BUSINESS_SEGMENTS_PARAMETERS_DATA:
      return {
        ...state,
        businessSegmentsParameters: { isLoading: true, data: [], error: null }
      };

    case NS_GET_CUSTOMER_VIEW_DATA:
      return {
        ...state,
        customerView: { isLoading: true, data: [], error: null }
      };

    case NS_GET_FIGURE_DATA_SUCCESS:
      return {
        ...state,
        figures: {
          isLoading: false,
          data: action.payload,
          error: null
        }
      };

    case NS_GET_ALERTS_HITS_CHART_SUCCESS:
      return {
        ...state,
        alertsAndHits: {
          isLoading: false,
          data: action.payload,
          error: null
        }
      };

    case NS_GET_HITS_DISTRIBUTION_CHART_SUCCESS:
      return {
        ...state,
        hitsDistribution: {
          isLoading: false,
          data: action.payload,
          error: null
        }
      };

    case NS_GET_SEGMENTS_SUCCESS:
      return {
        ...state,
        segments: {
          isLoading: false,
          data: action.payload,
          error: null
        }
      };

    case NS_GET_BUSINESS_SEGMENTS_PARAMETERS_DATA_SUCCESS:
      return {
        ...state,
        businessSegmentsParameters: {
          isLoading: false,
          data: action.payload,
          error: null
        }
      };

    case NS_GET_CUSTOMER_VIEW_DATA_SUCCESS:
      return {
        ...state,
        customerView: {
          isLoading: false,
          data: action.payload,
          error: null
        }
      };

    case NS_GET_FIGURE_DATA_FAIL:
      return {
        ...state,
        figures: { isLoading: false, data: null, error: action.payload }
      };

    case NS_GET_ALERTS_HITS_CHART_FAIL:
      return {
        ...state,
        alertsAndHits: { isLoading: false, data: null, error: action.payload }
      };

    case NS_GET_HITS_DISTRIBUTION_CHART_FAIL:
      return {
        ...state,
        hitsDistribution: {
          isLoading: false,
          data: null,
          error: action.payload
        }
      };

    case NS_GET_SEGMENTS_FAIL:
      return {
        ...state,
        segments: { isLoading: false, data: null, error: action.payload }
      };

    case NS_GET_BUSINESS_SEGMENTS_PARAMETERS_DATA_FAIL:
      return {
        ...state,
        businessSegmentsParameters: {
          isLoading: false,
          data: null,
          error: action.payload
        }
      };

    case NS_GET_CUSTOMER_VIEW_DATA_FAIL:
      return {
        ...state,
        customerView: { isLoading: false, data: null, error: action.payload }
      };

    default:
      return state;
  }
}
